import React, { useEffect, useState } from "react";
import { Logo, MainContainer, MenuItems } from "./styles";
import LogoBlack from "../../../../assets/svg/logo-black.svg";
import { menuItems } from "./menu";
import ItemMenu from "./ItemMenu";
import { Column } from "../../../../themes/globalStyle";
import { Divider } from "antd";
import User from "./User";
import { useLocation, useNavigate } from "react-router-dom";

const Menu: React.FC = (): JSX.Element => {
  const [selectedItem, setSelectedItem] = useState<string>("objetivos");

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1];

    const validSegments = menuItems.map((item) => item.id);
    if (validSegments.includes(lastSegment)) {
      setSelectedItem(lastSegment);
    } else {
      setSelectedItem("objetivos");
    }
  }, [location.pathname]);

  const handleSelectItem = (id: string) => {
    setSelectedItem(id);
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const basePath = pathSegments.slice(0, 2).join("/");
    navigate(`/${basePath}/${id}`);
  };

  return (
    <MainContainer>
      <Column style={{ gap: "4rem" }}>
        <Logo src={LogoBlack} />
        <MenuItems>
          {menuItems.map((item) => (
            <ItemMenu
              id={item.id}
              icon={item.icon}
              title={item.title}
              isSelected={selectedItem === item.id}
              onSelectItem={handleSelectItem}
            />
          ))}
        </MenuItems>
      </Column>
      <Column>
        {/* <Button
          size="large"
          backgroundColor={ThemeColors.Gradient100}
        >
          <Row>
            <FaFire  color="Bg300" />
            <Typography
              text="Otimizar resultados"
              size="medium"
              color="Bg300"
              weight={400}
            />
          </Row>
        </Button> */}
        <Divider />
        <User />
      </Column>
    </MainContainer>
  );
};

export default Menu;
